<template>
 <v-layout row>
    <v-flex xs12>
      <v-toolbar color="" >
          <v-toolbar-title class="text-xs-center">Emergencias</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list subheader>
          <v-subheader>Selecciona la Emergencia a reportar</v-subheader>
          <template v-for="item in items">
          <v-list-tile  avatar :key="item.id">
            <v-list-tile-avatar>
              <v-icon large :class="info">info</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.title"></v-list-tile-title>
            </v-list-tile-content>
            
          </v-list-tile>
          <v-divider :key="item.id + 'e'"></v-divider>
          </template>
          
        </v-list>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
        <div>
          <v-btn color="error" @click="logOut">LogOut</v-btn>
        </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data () {
    return {
      info: 'info',
      items: [
        { id: 0, active: true, title: 'Algun Problame', avatar: '/static/doc-images/lists/1.jpg' },
        { id: 1, active: true, title: 'Algun Problame', avatar: '/static/doc-images/lists/2.jpg' },
        { id: 2, title: 'Algun Problame', avatar: '/static/doc-images/lists/3.jpg' },
        { id: 3, title: 'Algun Problame', avatar: '/static/doc-images/lists/4.jpg' }
      ]
    }
  },
  methods: {
    logOut () {
      this.$store.dispatch('logout')
    }
  }
}
</script>
